/**
 * @generated SignedSource<<04734d10348b9c39f758d82e2b18b765>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateCompanyScheduleSettingsPayload",
            "kind": "LinkedField",
            "name": "updateCompanyScheduleSettings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfCompanyScheduleSettings",
                    "kind": "LinkedField",
                    "name": "scheduleSettingsEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CompanyScheduleSettings",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "viewAccessUntil",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditCompanyScheduleVisibilityMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditCompanyScheduleVisibilityMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "8fcca7ec8494955b6fb64cce5156a28a",
            "id": null,
            "metadata": {},
            "name": "EditCompanyScheduleVisibilityMutation",
            "operationKind": "mutation",
            "text": "mutation EditCompanyScheduleVisibilityMutation(\n  $model: UpdateCompanyScheduleSettingsRequestInput!\n) {\n  updateCompanyScheduleSettings(model: $model) {\n    scheduleSettingsEdge {\n      node {\n        id\n        viewAccessUntil\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "6941113bf4728e98981deebfa9c069e3";
export default node;
